import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LegendComponent } from './legend.component';
import { LegendItemComponent } from './legend-item.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    LegendComponent,
    LegendItemComponent
  ],
  exports: [
    LegendComponent,
    LegendItemComponent
  ]
})
export class LegendModule {
}
